import { ApiPayload } from '../api'

export { UefaApiResult as UefaScheduleListResult } from '@rtl/api'
export { UefaApiResult as UefaScoreListResult } from '@rtl/api'
export { UefaApiResult as UefaTeamStatResult } from '@rtl/api'
export { UefaApiResult as UefaPlayerStatResult } from '@rtl/api'

export type UefaScheduleListPayload = ApiPayload<{}>
export type UefaScoreListPayload = ApiPayload<{ _pgNm?: number, _pgSz?: number }>
export type UefaPlayerStatPayload = ApiPayload<{}>
export type UefaTeamStatPayload = ApiPayload<{}>

export interface UefaState {}

export enum UEFA_ACTION {
  SCHEDULE_LIST = 'fetchUefaScheduleList',
  SCORE_LIST = 'fetchUefaScoreList',
  PLAYER_STAT = 'fetchUefaPlayerStat',
  TEAM_STAT = 'fetchUefaTeamStat'
}

export enum UEFA_GETTER {
  API = 'api'
}

export const UEFA_NAMESPACE = 'uefa'
